import { Trash } from "react-bootstrap-icons";

import SettingsCard from "./SettingsCard";

export default function DangerZone() {
  return (
    <SettingsCard
      icon={<Trash />}
      title="Danger zone"
      description="Irreversible and destructive actions."
      className="danger-card"
      iconClassName="danger-icon"
    >
      <div className="danger-box">
        <div>
          <strong>Delete account</strong>

          <p>
            Permanently delete your account and all of your data. This
            action cannot be undone.
          </p>
        </div>

        <button type="button">
          Delete account
        </button>
      </div>
    </SettingsCard>
  );
}